/*
 * Order statuses:
 */
export const Single_Selected = 1;
export const Multi_Selected = 2;
export const Auto_Applied = 4;
